import { Component, EventEmitter, Input, Output } from '@angular/core';

let uniqueRadioId = 0;

@Component({
  selector: 'fi-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  standalone: false,
})
export class RadioComponent {
  @Input() name = `fi-radio-${uniqueRadioId++}`;
  @Input() value: unknown;
  @Input() checked = false;
  @Input() disabled = false;
  @Input() block = false;
  @Input() hint?: string;
  @Input() error?: string;
  @Input() required = false;

  @Output() checkedChange = new EventEmitter<boolean>();
  @Output() valueChange = new EventEmitter<unknown>();

  onInputChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.checked = checked;
    this.checkedChange.emit(checked);
    if (checked) {
      this.valueChange.emit(this.value);
    }
  }
}
